export const locationContactStyles = {
  textContainer: {
    my: {
      mobile: "1.5rem",
      tablet: "unset",
    },
    textAlign: {
      tablet: "left",
    },
  },
  subheading: {
    color: "black.main",
    textTransform: "capitalize",
    fontWeight: "700",
    fontSize: "1rem",
    lineHeight: "1.625rem",
  },
  title: {
    color: "black.main",
    fontSize: "1rem",
    lineHeight: "1.625rem",
  },
};
